import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { StepCard } from '../../../PulseCheck.styles';
import { cardAnimationVariants } from '../../../../BeFi20/BeFi20.meta';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { useSetGoalContext } from '../../context/useSetGoalContext';
import {
  EXPENSE_GOAL_LABEL,
  FormValues,
  LARGE_PURCHASE_GOAL_LABEL,
  validation,
} from './GoalType.meta';
import { VisualPicker } from '../../../../CommonComponents/OPL/VisualPicker/VisualPicker';
import { FinancialGoalType } from '../../context/SetGoalProvider';
import { HelperText } from '../../../../CommonComponents/OPL/HelperText/HelperText';
import { FORM_ID } from '../../SetGoal.meta';
import { StepWrapper } from '../../../components/StepWrapper/StepWrapper';

export const GoalType = () => {
  const { wizard, setWizard, onSuccess } = useSetGoalContext();

  const { control, formState, handleSubmit } = useForm<FormValues>({
    defaultValues: {
      goalType: wizard.goalType,
    },
    resolver: yupResolver(validation),
  });

  const onSubmit = handleSubmit(values => {
    const newWizard = { ...wizard, ...values };

    setWizard(newWizard);

    onSuccess(newWizard);
  });

  return (
    <StepWrapper as="form" id={FORM_ID} onSubmit={onSubmit}>
      <StepCard variants={cardAnimationVariants} initial="enter" animate="visible">
        <Text as="h1" fontSize="h4" fontWeight={600} mb="16">
          Choose the option that best supports your goal
        </Text>

        <Controller
          control={control}
          name="goalType"
          render={({ field: { value, onChange } }) => (
            <Box
              display="flex"
              flexDirection="column"
              role="radiogroup"
              aria-label="Choose the option that best support your goal"
              css="gap: 16px"
            >
              <VisualPicker
                label={LARGE_PURCHASE_GOAL_LABEL}
                onChange={() => onChange(FinancialGoalType.LargePurchase)}
                checked={value === FinancialGoalType.LargePurchase}
              />

              <VisualPicker
                label={EXPENSE_GOAL_LABEL}
                onChange={() => onChange(FinancialGoalType.Expense)}
                checked={value === FinancialGoalType.Expense}
              />

              {formState.errors?.goalType && (
                <HelperText variant="error" mt="4">
                  {formState.errors.goalType.message}
                </HelperText>
              )}
            </Box>
          )}
        />
      </StepCard>
    </StepWrapper>
  );
};
